// Import External Dependencies
import React, { useContext } from 'react'
import { store } from '../store'
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import Breadcrumb from '../components/breadcrumbs/Breadcrumb'

import { CrumbRouteProps } from './types'

export const CrumbRoute = ({ children, companyRequired, includeSearch, title, path }: CrumbRouteProps) => {
  const globalState = useContext(store)
  const { state } = globalState
  const { isAuthenticated, userIsWarehouse, actAs } = state
  const params = useParams()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to={`/login?next=${location.pathname}`} />
  }

  if (userIsWarehouse && companyRequired && !actAs) {
    return (
      <Navigate
        to={{
          pathname: '/warehouse/companies',
          search: '?returnto=' + location.pathname,
        }}
      />
    )
  }

  // Replace dynamic parameters in path with their actual values
  let resolvedPath = path || location.pathname
  if (path) {
    Object.entries(params).forEach(([key, value]) => {
      resolvedPath = resolvedPath.replace(`:${key}`, value)
    })
  }

  return (
    <Breadcrumb
      data={{
        title: title || '',
        pathname: resolvedPath,
        search: includeSearch ? location.search : '',
      }}
    >
      <>
        <Helmet>
          <title>Kase{title ? ` - ${title}` : ''}</title>
          <meta name="viewport" content="initial-scale=1, maximum-scale=0.8" />
        </Helmet>
        {children || <Outlet />}
      </>
    </Breadcrumb>
  )
}

export default CrumbRoute
